import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {USER_COOKIE, USER_ROLE} from "../lib/constants";

let userObject = {
    id: null,
    name: null,
    email: null,
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    initialize: () => {
        user.update(obj => {
            // let coo = JSON.parse(cookie.get(USER_COOKIE) || "{}");
            // obj.token = coo.token;
            obj.token = cookie.get(USER_COOKIE) || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.agent_id = data.agent_id;
            obj.name = data.name;
            obj.email = data.email;
            obj.role = ~~data.role;
            if (data.token !== undefined) {
                obj.token = data.token;
            }
            user.saveCookie();
            return obj;
        });
    },

    // setToken: (token) => {
    //     user.update(obj => {
    //         obj.token = token;
    //         user.saveCookie();
    //         return obj;
    //     });
    // },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        let coo = {
            token: userObject.token,
        };
        // console.log("saveCookie", coo);
        // cookie.create(USER_COOKIE, JSON.stringify(coo));
        cookie.create(USER_COOKIE, userObject.token);
    },

    isAdmin: () => {
        return userObject.role == USER_ROLE.ADMIN;
    },

    isAgent: () => {
        return userObject.role == USER_ROLE.AGENT;
    },
}

export default user;